import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PROJECT_STATE_TAG_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, PROJECT_STATE_TAG_TRANSLATION_KEY, {
  PARTICIPATION_PROJECT: 'Participation Project',
  FREE_COURSE: 'Free Course',
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  OBSERVED: 'Observed',
  CERTIFIED: 'Certified',
  APPROVED: 'Approved',
  FINISHED: 'Finished',
  EXPIRED: 'Expired',
  TEACHER_PROJECT: 'Teacher Project'
});